import { PhotoDisplayHandler } from "components";
import LinkLanguage from "locales/LinkLanguage";
import "./MobileMenuItem.scss";

type MobileMenuItemProps = {
  path: string;
  action: (param1: string, param2?: string, param3?: string) => void;
  item: any; // TODO ovde dodati tip itema
  style: string;
};

const MobileMenuItem = ({ path, action, item, style }: MobileMenuItemProps) => {
  return (
    <LinkLanguage
      className={style}
      to={path}
      action={action}
      key={item.slug}
      needNavigation={false}
    >
      <div className="Mobile-Menu-Item">
        <div className="Mobile-Menu-Item-Icon">
          <PhotoDisplayHandler
            img_name={item.img_path}
            calculate={false}
            img_class_name="Mobile-Menu-Item-Photo"
            img_alt={item.ac_name}
            width="25px"
            height="25px"
          />
        </div>
        <div className="Mobile-Menu-Item-Label">{item.ac_name}</div>
      </div>
    </LinkLanguage>
  );
};
export default MobileMenuItem;
